module.exports = __webpack_public_path__ + "static/media/13.44515472.jpg";